export default __webpack_public_path__ + "static/media/hero.58cbc98e.png";